import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import Spinner from '../../util/spinner-shim'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import moment from 'moment'
import { useParams, useNavigate } from 'react-router-dom'

import statusCalculate from 'altrac-application-status'
import { isNumber } from 'altrac-conversions'
import { IconLink } from '../partials/Navigation/Buttons'
import AppDispatcher from '../../dispatchers/AppDispatcher'
import AppStore from '../../stores/AppStore'
import withAppStore from '../../util/withAppStore'
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import Headline from '../partials/ConfigurePageComponents/Headline'
import TelemetryButtons from '../partials/ConfigurePageComponents/TelemetryButtons'
import DateRangePicker from '../partials/ConfigurePageComponents/DateRangePicker'
import { useDateRangePicker } from '../partials/ConfigurePageComponents/useDateRangePicker'
import pageStyles from '../../../css/devicePage.module.css'
import Highcharts from 'highcharts'
import { Chart as HighchartsReact } from '@highcharts/react'


const split = (input, physical) => {
  if (!input) {
    return null
  }
  const output = input.match(/\{\{([a-zA-Z0-9 ]*\|[a-zA-Z0-9 ]*)\}\}/)
  if (!output) {
    return input
  }
  const arr = output[1].split('|')
  let returnValue
  if (physical && typeof physical === 'object' && physical.hasOwnProperty(arr[0])) {
    returnValue = physical[arr[0]]
  } else {
    returnValue = arr[1]
  }
  if (isNumber(returnValue)) returnValue = Number(returnValue)
  return returnValue
}

const Sections = (props) => {
  const {
    dateBegin,
    dateEnd,
    dateType,
    dayPickerIsVisible,
    draftRange,
    device,
    deviceStatus,
    customer,
    statsLookup,
    statsReady,
    pinCode,
    toPumpCombinedSettings,
    section: {
      name: sectionName,
      chart: chartInterface,
      telemetryTypes,
    },
    chartsData,
    editDateRange,
    closeDayPicker,
    handleDayClick,
    index,
    level,
    tempConv
  } = props

  let physical
  if (device && device.physical) physical = device.physical

  const [chartInst, setChartInst] = useState(false)

  const catchChart = (_chartInst) => {
    setChartInst(_chartInst)
  }

  const divStyle = { float: 'left', width: '100%' }
  if (index > 0) divStyle.marginTop = '20px'
  const sectionNameD = split(sectionName, physical)
  const toReturn = [
    <div key={0} style={divStyle} className={pageStyles.sectionName}>
      <h4>{sectionNameD}</h4>
    </div>,
  ]

  let height = '225px'

  const dataReady = chartsData && (statsReady === 'loaded' || statsReady === 'loading')

  let seriesData

  if (chartInterface && typeof chartInterface === 'object' && dataReady) {
    if (chartInterface.height) {
      height = chartInterface.height
    }
    const {
      name = '',
      series = [],
      yAxis = [{
        min: 0,
        max: 1,
        title: {
          enabled: false,
        },
        allowDecimals: false,
        endOnTick: false,
        startOnTick: false,
        opposite: true,
        visible: false,
      }, {
        title: {
          enabled: false,
        },
        allowDecimals: false,
      }],
    } = chartInterface

    seriesData = series.reduce((acc, cur) => {
      if (!dataReady || !chartsData[name] || !physical) return acc
      let {
        label,
      } = cur
      label = split(label, physical)
      if (chartsData[name][label]) {
        const {
          type,
          color,
          shadow = false,
          yAxis: yAxisSer = 0,
          pointWidth,
          lineWidth = 2,
          fillOpacity = 1,
        } = cur
        acc.push({
          name: label,
          data: chartsData[name][label],
          type,
          color,
          fillOpacity,
          shadow,
          lineWidth,
          yAxis: yAxisSer,
          pointWidth,
        })
      }
      return acc
    }, [])
    if (chartInst) {
      if (!dataReady) {
        chartInst.showLoading()
      } else {
        chartInst.hideLoading()
      }
    }
    toReturn.push(
      <div key={1} style={{ float: 'left' }}>
        <div className={pageStyles.chartContainer} style={{ padding: '10px 0px', height: 'inherit' }}>
          <div className={pageStyles.dateRangePickerInside} style={{ display: 'flex' }}>
            <DateRangePicker
              dateBegin={dateBegin}
              dateEnd={dateEnd}
              dateType={dateType}
              dayPickerIsVisible={dayPickerIsVisible}
              draftRange={draftRange}
              onClose={closeDayPicker}
              onEditRange={editDateRange}
              onDayClick={handleDayClick}
              layout='inline'
              buttonStyle={{ flex: 1, marginLeft: '35px' }}
            />
          </div>
          <HighchartsReact
            highcharts={Highcharts}
            callback={catchChart}
            options={{
              accessibility: {
                enabled: false,
              },
              time: {
                useUTC: true,
              },
              title: { text: '' },
              chart: {
                height,
                zoomType: 'x',
                panning: {
                  enabled: true,
                },
                animation: false,
                resetZoomButton: {
                  theme: {
                    display: 'none',
                  },
                },
              },
              tooltip: {
                shared: true,
              },
              xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: {
                  day: '%e %b',
                  month: '%b %e',
                  year: '%b',
                },
                title: {
                  enabled: false,
                },
                // tickInterval: 1000 * 60 * 60 * 24,
                tickPixelInterval: 75,
              },
              yAxis,
              plotOptions: {
                series: {
                  states: {
                    inactive: {
                      enabled: false,
                    },
                  },
                },
              },
              legend: {
                enabled: true,
              },
              series: seriesData,
              credits: {
                enabled: false,
              },
              exporting: {
                enabled: false,
              },
            }}
          />
        </div>
      </div>
    )
  } else if (chartInterface && typeof chartInterface === 'object') {
    toReturn.push(
      <div
        key={2}
        className={pageStyles.chartContainer}
        style={{
          padding: '10px 0px',
          height: `calc(${height} + 57px)`,
          float: 'left',
          position: 'relative',
        }}
      >
        <div style={{
          height: '100%',
          width: '100%',
          float: 'left',
          position: 'relative',
          backgroundColor: 'white',
        }}
        >
          <Spinner
            name='wave'
            color='#284047'
            style={{
              position: 'absolute',
              top: '50%',
              right: '50%',
              transform: 'translate(50%, -50%)',
            }}
          />
        </div>
      </div>
    )
  }

  if (telemetryTypes && Array.isArray(telemetryTypes) && telemetryTypes.length > 0) {
    toReturn.push(
      <div key={3} style={{ float: 'left' }}>
        <TelemetryButtons
          device={device}
          status={deviceStatus}
          path={`/${device.customer_id}/devices/${device.id}/`}
          telemetryTypes={telemetryTypes}
          statsLookup={statsLookup}
          statsReady={statsReady}
          customer={customer}
          pinCode={pinCode}
          tempConv={tempConv}
          level={level}
        />
      </div>
    )
  } else if (seriesData && seriesData.length > 0) {
    const outputs = []
    seriesData.forEach((iter) => {
      outputs.push(
        <IconLink
          key={`${iter.name}${iter.color}`}
          label={iter.name}
          value={iter.data && iter.data.length > 0 && iter.data[iter.data.length - 1][1] ? iter.data[iter.data.length - 1][1] : 0}
        />
      )
    })
    toReturn.push(
      <div key={4} className={pageStyles.tileContainer} style={{ float: 'left' }}>
        {outputs}
      </div>
    )
  }
  return toReturn
}

function PumpPage (props) {
  const { customerID, deviceID } = useParams()
  const navigate = useNavigate()

  // Memoize initial dates to prevent unnecessary re-renders
  const initialDateBegin = React.useMemo(
    () => moment().startOf('day').subtract(10, 'days'),
    []
  )
  const initialDateEnd = React.useMemo(
    () => moment().endOf('day'),
    []
  )

  // Use the shared date range picker hook
  const dateRangePicker = useDateRangePicker(initialDateBegin, initialDateEnd)

  const [state, setState] = React.useState({
    viewDays: 10,
    statsReady: 'notLoaded',
  })

  // Sync date range picker state with local state when needed
  const { dateBegin, dateEnd, dateType, dayPickerIsVisible, draftRange } = dateRangePicker.state

  const resizeTimeout = React.useRef(false)

  const getDevice = React.useCallback(() => {
    AppDispatcher.dispatch({ action: 'get-device', deviceID })
  }, [deviceID])

  const back = React.useCallback(() => {
    const { data: { history: { list = [] } = {} } = {} } = props
    navigate(list.length > 0 ? list : '/home')
  }, [props.data.history.list, navigate])

  const goto = React.useCallback((path) => {
    navigate(path)
  }, [navigate])

  const toAdvancedSettings = React.useCallback(() => {
    goto(`/${customerID}/devices/${deviceID}/settings`)
  }, [customerID, deviceID, goto])

  const toPumpCombinedSettings = React.useCallback(() => {
    goto(`/${customerID}/pump/${deviceID}/settings`)
  }, [customerID, deviceID, goto])

  // Use handlers from the date range picker hook
  const { closeDayPicker, editDateRange, handleDayClick, setDateRange, applyDraftRange } = dateRangePicker

  const resetDateRange = React.useCallback(() => {
    const dateBegin = moment()
      .startOf('day')
      .subtract(state.viewDays, 'days')
      .add(1, 'days')

    const dateEnd = moment()
      .endOf('day')

    setDateRange(dateBegin, dateEnd)
  }, [state.viewDays, setDateRange])

  // Use resetToLast31Days from the hook
  const { resetToLast31Days } = dateRangePicker

  const onChange = React.useCallback(() => {
    const { statsReady } = state
    const {
      data: {
        statsReady: statsReadyN,
      },
    } = AppStore
    if (statsReady !== statsReadyN) {
      setState(prev => ({ ...prev, statsReady: statsReadyN }))
    }
  }, [state.statsReady])

  const handleResize = React.useCallback(() => {
    clearTimeout(resizeTimeout.current)
    resizeTimeout.current = setTimeout(() => {
      // Force re-render
      setState(prev => ({ ...prev }))
    }, 500)
  }, [])

  React.useEffect(() => {
    getDevice()
    AppStore.addChangeListener(onChange)
    window.addEventListener('resize', handleResize)
    const interval = setInterval(getDevice, 5000)

    return () => {
      AppStore.removeListener('change', onChange)
      window.removeEventListener('resize', handleResize)
      clearInterval(interval)
    }
  }, [getDevice, onChange, handleResize])

  // Separate effect for stats polling interval
  React.useEffect(() => {
    const interval = setInterval(() => {
      if (dateBegin && dateEnd && !dayPickerIsVisible) {
        AppDispatcher.dispatch({
          action: 'get-pump-stats',
          deviceID,
          timeBeg: dateBegin.toISOString(),
          timeEnd: dateEnd.toISOString(),
          utcOffset: moment().utcOffset() / 60,
        })
      }
    }, 60000)

    return () => {
      clearInterval(interval)
    }
  }, [deviceID, dateBegin, dateEnd, dayPickerIsVisible])

  React.useEffect(() => {
    const { data: { lookupReady, lookup } = {} } = props || {}
    const device = lookup[deviceID]

    if (lookupReady && device) {
      const {
        physical: {
          pumpSettings: {
            viewDays: newViewDays = 10,
          } = {},
        } = {},
      } = device || {}

      const { viewDays } = state

      if (viewDays !== newViewDays) {
        setState(prev => ({ ...prev, viewDays: newViewDays }))
      }
    }
  }, [props.data.lookupReady, props.data.lookup, deviceID, state.viewDays])

  // Effect to handle date range changes and fetch stats
  React.useEffect(() => {
    // Only fetch stats if dates have been set and day picker is not visible
    if (dateBegin && dateEnd && !dayPickerIsVisible) {
      AppDispatcher.dispatch({
        action: 'get-pump-stats',
        deviceID,
        timeBeg: dateBegin.toISOString(),
        timeEnd: dateEnd.toISOString(),
        utcOffset: moment().utcOffset() / 60,
      })
    }
  }, [deviceID, dateBegin, dateEnd, dayPickerIsVisible])

  // Effect to handle viewDays changes and reset date range
  // Use a ref to track the last viewDays value to prevent infinite loops
  const prevViewDaysRef = React.useRef(state.viewDays)
  React.useEffect(() => {
    const { viewDays } = state
    // Only reset if viewDays actually changed and is valid
    if (viewDays && viewDays !== prevViewDaysRef.current) {
      prevViewDaysRef.current = viewDays
      resetDateRange()
    }
  }, [state.viewDays, resetDateRange])

  const render = () => {
    const {
      data: {
        lookupReady,
        lookup,
        stats: { charts: chartsData } = {},
        statsLookup,
        pinCode,
        customer: {
          data: customer,
        },
      } = {},
    } = AppStore

    const {
      statsReady,
    } = state

    const {
      dateBegin,
      dateEnd,
      dateType,
      dayPickerIsVisible,
    } = dateRangePicker.state

    const {
      auth: { logout },
      intl: { formatMessage },
    } = props

    const title = `${formatMessage({
      id: 'pump.stats.title',
      defaultMessage: 'Pump',
      description: 'pump page title',
    })}`

    let pageContents = [(
      <div key={0} style={{ height: '400px', position: 'relative' }}>
        <Spinner
          name='wave'
          style={{
            position: 'absolute',
            top: '50%',
            right: '50%',
            transform: 'translate(50%, -50%)',
          }}
        />
      </div>
    )]

    let name
    let device
    let headline = ''

    let deviceStatus
    if (lookupReady && lookup) {
      device = lookup[deviceID]
      deviceStatus = statusCalculate(device)

      const {
        physical: {
          deviceNumber,
        } = {},
      } = device || {}

      name = deviceNumber

      const {
        deviceHeadlineDanger,
        deviceHeadlineWarning,
      } = deviceStatus

      headline = (
        <div>
          <Headline
            key={1}
            info={deviceHeadlineDanger}
            prepend={formatMessage({
              id: 'headline.error',
              defaultMessage: 'ERROR: ',
              description: '',
            })}
          />
          <Headline
            key={2}
            info={deviceHeadlineWarning}
            prepend={formatMessage({
              id: 'headline.warning',
              defaultMessage: 'WARNING: ',
              description: '',
            })}
          />
        </div>
      )
    }

    if (lookupReady && lookup) {
      const {
        interface_versioned: {
          data: {
            primaryPage: {
              sections = [],
            } = {},
          } = {},
        } = {},
      } = device || {}

      if (sections && Array.isArray(sections) && sections.length > 0) {
        pageContents = sections.map((e, index) => (
          <Sections
            key={`${device.id}-${index}`}
            device={device}
            deviceStatus={deviceStatus}
            customer={customer}
            statsLookup={statsLookup}
            statsReady={statsReady}
            pinCode={pinCode}
            dateBegin={dateBegin}
            dateEnd={dateEnd}
            dateType={dateType}
            dayPickerIsVisible={dayPickerIsVisible}
            draftRange={draftRange}
            toPumpCombinedSettings={toPumpCombinedSettings}
            section={e}
            chartsData={chartsData}
            editDateRange={editDateRange}
            closeDayPicker={closeDayPicker}
            handleDayClick={handleDayClick}
            index={index}
            level={props.level}
            tempConv={props.data.user?.locale?.tempConv || 'f'}
          />
        ))
      }
    }

    return (
      <div>
        <Helmet><title>{title}</title></Helmet>
        <DateRangePicker
          dateBegin={dateBegin}
          dateEnd={dateEnd}
          dateType={dateType}
          dayPickerIsVisible={dayPickerIsVisible}
          draftRange={draftRange}
          onClose={closeDayPicker}
          onEditRange={editDateRange}
          onDayClick={handleDayClick}
          onApplyRange={applyDraftRange}
          onResetToLast31Days={resetToLast31Days}
          layout='modal'
        />
        <NavigationBar
          backFunc={back}
          page='/pump'
          logOut={() => logout(navigate)}
          name={name}
          rightControl={{
            icon: 'fa-cog',
            func: toAdvancedSettings,
          }}
        />
        <div className={pageStyles.pageWidth}>
          <div className={pageStyles.pageContainer}>
            {headline}
            {pageContents}
          </div>
        </div>
        <Footer />
      </div>
    )
  }

  return render()
}

PumpPage.propTypes = {
  auth: PropTypes.object,
  data: PropTypes.object,
  viewDays: PropTypes.number,
}

export default withAppStore(injectIntl(PumpPage))
